import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";
import { TextSection } from "container/Manual/components/section/TextSection";

export const REPLACE = () => {
  return (
    <CardSection id="REPLACE" title="REPLACE">
      <Paragraph>
        지정한 문자 수에 따라 텍스트 문자열의 일부를 다른 텍스트 문자열로
        바꿉니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>
          REPLACE(VALUE, START NUM,NUM CHARS, NEW VALUE)
        </Paragraph>
        <Ul>
          <Li>
            <b>VALUE</b>는 문자를 바꾸려는 텍스트 또는 열입니다.
          </Li>
          <Li>
            <b>START NUM</b>은 VALUE에서 바꾸고자 하는 문자의 시작 위치입니다.
          </Li>
          <Li>
            <b>NUM CHARS</b>는 새 문자열로 바꾸려는 텍스트의 문자 수입니다.
          </Li>
          <Li>
            <b>NEW VALUE</b>는 대체 값입니다. 대소문자를 구분합니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>REPLACE(`product`, 6, 6, "")</Paragraph>
        <Img src="computeReplace" />
      </ListSection>

      <ListSection title="Notes on use">
        <TextSection>
          텍스트 문자열의 특정 위치에 나타나는 모든 텍스트를 바꾸려면 REPLACE를
          사용하세요.
          <br />
          예:
          <Paragraph accent>
            REPLACE(`Hospital Name`, Search(`Hospital Name`, "ADVOCATE"), 8,
            "ALPHA")
          </Paragraph>
        </TextSection>
      </ListSection>
    </CardSection>
  );
};
